import React from 'react';
import styles from './index.css';
import { getClsData } from '../../../../../../services/api';
import errorBoundary from '@ifeng/errorBoundary';

class Topic extends React.PureComponent {
    state = {
        topic: '',
    };

    /**
     * 请求 Topic
     */
    componentDidMount() {
        this.getData();

        this.timer = setInterval(() => {
            this.getData();
        }, 30000);
    }

    /**
     * 卸载定时器
     */
    componentWillUnmount() {
        clearInterval(this.timer);
    }

    getData = async () => {
        try {
            const data = await getClsData(Date.parse(new Date()));

            if (data.data && data.data.length > 0) {
                this.setState({
                    topic: data.data[0].brief,
                });
            }
        } catch (e) {
            console.error(e);
        }
    };

    createMarkup = () => {
        const { topic } = this.state;

        return { __html: topic };
    };

    /**
     * 渲染组件
     */
    render() {
        const { topic } = this.state;

        return (
            <div className={styles.topic}>
                <span className={styles.icon} />
                <p>
                    <a href="//finance.ifeng.com/studio" target="_blank" title={topic}>
                        <span dangerouslySetInnerHTML={this.createMarkup()} />
                    </a>
                </p>
            </div>
        );
    }
}

export default errorBoundary(Topic);
